import { render, staticRenderFns } from "./BpmEditor.vue?vue&type=template&id=2e526242&scoped=true&"
import script from "./BpmEditor.vue?vue&type=script&lang=js&"
export * from "./BpmEditor.vue?vue&type=script&lang=js&"
import style0 from "./BpmEditor.vue?vue&type=style&index=0&id=2e526242&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e526242",
  null
  
)

export default component.exports